module.exports = __webpack_public_path__ + "static/media/background-4.a1984849.png";